<script lang="ts">
  import {cn} from 'Catalyst/cn';
  import {Icon} from 'Catalyst/components/Icon';
  import {type SectionNoticeProps, sectionNoticeTvProps} from '.';
  import {
    sectionNoticeVariantsSemanticNeutralIconGlyph,
    sectionNoticeVariantsSemanticInfoIconGlyph,
    sectionNoticeVariantsSemanticErrorIconGlyph,
    sectionNoticeVariantsSemanticWarningIconGlyph,
    sectionNoticeVariantsSemanticSuccessIconGlyph,
    sectionNoticeVariantsSemanticBrandIconGlyph,
    sectionNoticeSlotsIconDensity,
    sectionNoticeSlotsIconSize,
  } from 'Catalyst/tokens/output/section-notice';

  // eslint-disable-next-line no-unused-vars
  type $$Props = SectionNoticeProps;

  const iconSemanticMap = {
    neutral: sectionNoticeVariantsSemanticNeutralIconGlyph,
    info: sectionNoticeVariantsSemanticInfoIconGlyph,
    error: sectionNoticeVariantsSemanticErrorIconGlyph,
    warning: sectionNoticeVariantsSemanticWarningIconGlyph,
    success: sectionNoticeVariantsSemanticSuccessIconGlyph,
    brand: sectionNoticeVariantsSemanticBrandIconGlyph,
  };

  export let title: SectionNoticeProps['title'] = '';
  export let message: SectionNoticeProps['message'] = '';
  export let semantic: SectionNoticeProps['semantic'] =
    sectionNoticeTvProps.defaultVariants.semantic;
  export let icon: SectionNoticeProps['icon'] = iconSemanticMap[
    semantic
  ] as SectionNoticeProps['icon'];

  const sectionNoticeTvSlots = sectionNoticeTvProps({semantic});

  const klass = $$restProps.class;
</script>

<div {...$$restProps} class={cn(sectionNoticeTvSlots.base(), klass)}>
  <Icon
    class={cn(sectionNoticeTvSlots.icon())}
    name={icon}
    density={sectionNoticeSlotsIconDensity}
    size={sectionNoticeSlotsIconSize}
  />
  <div>
    {#if title}
      <div
        class={cn(sectionNoticeTvSlots.title(), 'mb-1')}
        data-testid="section-notice-title"
      >
        <span>{title}</span>
      </div>
    {/if}
    <div class={cn(sectionNoticeTvSlots.message())}>
      <span>
        {#if $$slots.default}
          <slot />
        {:else}
          {message}
        {/if}
      </span>
    </div>
  </div>
</div>
